import { Component, OnInit, ViewChild } from '@angular/core';
import {  ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

import { GlobalService } from 'src/app/_services/global.service';

import { Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

import {
  ColDef,
  CellEditingStartedEvent,
  GridReadyEvent,
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';

@Component({
  selector: 'app-checkl-models',
  templateUrl: './checkl-models.component.html',
  styleUrls: ['./checkl-models.component.css'],
  providers: [ MessageService,ConfirmationService]
})

export class ChecklModelsComponent implements OnInit {

  columns: ColDef[] = [
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
          if(typeof params.value == 'undefined')
            return '';
            return '<a title="'+'Modifica modello'+'"><i class="pointer pi pi-pencil"></i></a>'; 
      },
      onCellClicked:function(data){ 
          _this.router.navigate(['/dashboard/checklists/checkl-model-edit/update',data.data.id]);
      }   
    },
 
    
    { field: 'name',headerName: 'Titolo' },
   
    { field: 'status',headerName: 'Stato' },
      
      
  
    { field: 'questions_count',headerName: 'Domande' },
    { field: 'id',  
      headerName: '', 
      maxWidth:50,
      cellRenderer: params =>    {   
        
          if(typeof params.value == 'undefined')
            return '';
          if(params.data.status != 'DRAFT')
            return '';
     
          return '<a title="'+'Elimina modello'+'"><i class="pointer pi pi-trash"></i></a>'; 
      },
      onCellClicked:function(params){ 

          if(params.data.status != 'DRAFT')
              return '';
            console.log(111);
          _this.confirmationService.confirm({
            message: 'Attenzione: si conferma la cancellazione?',
            accept: () => {
              _this.apiService.delCheckListModel({id:params.data.id}).subscribe(data => {
                _this.addSingle('success', 'Success', 'Modello eliminato');
                _this.load();
              });
            }
          });
      }   
    },
  ];
  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }
  checklmodelslist: any[] = [];
  gridApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

 
  
  defaultSortModel = [
    { colId: 'name', sort: 'asc', sortIndex: 0 },
  ];

 
  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.showLoadingOverlay();
    params.columnApi.applyColumnState({ state: this.defaultSortModel });
  }

  constructor(
    private router: Router,
    private messageService: MessageService,
    private translate: TranslateService,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    public confirmationService: ConfirmationService
  ) { }

  
  ngOnInit(): void {
    _this=this;
    this.load();
   
  }

  load(){
    const params: any = {PageSize : 10000};
    this.apiService.get('checklists/listall',params).subscribe(data => {
      this.checklmodelslist=data.Result;
      });
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }


}
var _this;